import React from 'react';
import { FESTIVE_ART } from './festiveArt';
import { festivalRange, festivalTag, formatShortDate } from './festivals.config';

// Scoped under .cxf so nothing here can leak into the rest of the app.
const CSS = `
.cxf{position:relative;display:flex;align-items:center;gap:16px;padding:14px 20px 14px 24px;border-radius:16px;overflow:hidden;
  border:1px solid color-mix(in srgb,var(--f1) 22%,var(--line));
  background:linear-gradient(100deg,color-mix(in srgb,var(--f1) 9%,var(--card)),color-mix(in srgb,var(--f2) 8%,var(--card)))}
.cxf:before{content:"";position:absolute;left:0;top:0;bottom:0;width:5px;background:linear-gradient(var(--f1),var(--f2))}
.cxf-tx{flex:1;min-width:0}
.cxf-eb{font-size:10.5px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:var(--fa);display:flex;align-items:center;flex-wrap:wrap;gap:4px 10px}
.cxf-tg{font-size:10.5px;font-weight:700;letter-spacing:.02em;text-transform:none;color:var(--fa);background:color-mix(in srgb,var(--f1) 12%,var(--card));border-radius:20px;padding:2px 10px;white-space:nowrap}
.cxf-ti{font-size:19px;font-weight:700;letter-spacing:-.01em;margin:2px 0 3px;color:var(--text)}
.cxf-su{color:var(--muted);font-size:12.5px;max-width:640px;line-height:1.5}
.cxf-sg{color:var(--text);font-weight:600}
.cxf-th{margin-top:5px;font-size:12.5px;font-style:italic;color:var(--fa);font-weight:500}
.cxf-art{flex:none;width:230px;height:100px;color:var(--f1);margin-right:14px;-webkit-mask-image:linear-gradient(90deg,transparent,#000 16%);mask-image:linear-gradient(90deg,transparent,#000 16%)}
.cxf-art svg{width:100%;height:100%;overflow:visible}
.cxf-art [class]{transform-box:fill-box;transform-origin:center}
.cxf.tri:after{content:"";position:absolute;left:5px;right:0;bottom:0;height:3px;background:linear-gradient(90deg,#ff9933 33%,#fff 33% 66%,#138808 66%)}
@media(max-width:760px){.cxf-art{display:none}}
@media(max-width:640px){.cxf{padding:14px 16px 14px 20px}.cxf-eb{letter-spacing:.06em}}
@keyframes cxfa-pulse{0%,100%{opacity:.6;transform:scale(1)}50%{opacity:1;transform:scale(1.05)}}
@keyframes cxfa-spin{to{transform:rotate(360deg)}}
@keyframes cxfa-spinr{to{transform:rotate(-360deg)}}
@keyframes cxfa-flick{0%,100%{transform:scale(1,1) skewX(0)}25%{transform:scale(.92,1.09) skewX(3deg)}50%{transform:scale(1.06,.94) skewX(-3deg)}75%{transform:scale(.95,1.06) skewX(2deg)}}
@keyframes cxfa-glow{0%,100%{opacity:.16;transform:scale(1)}50%{opacity:.38;transform:scale(1.25)}}
@keyframes cxfa-rise{0%{transform:translateY(0);opacity:0}15%{opacity:.9}100%{transform:translateY(-30px);opacity:0}}
@keyframes cxfa-float{0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)}}
@keyframes cxfa-wave{from{transform:translateX(0)}to{transform:translateX(-40px)}}
@keyframes cxfa-blink{0%,90%,100%{transform:scaleY(1)}94%{transform:scaleY(.08)}}
@keyframes cxfa-arrow{0%{transform:translateX(0);opacity:0}6%,30%{transform:translateX(0);opacity:1}50%{transform:translateX(44px);opacity:1}52%,100%{transform:translateX(44px);opacity:0}}
@keyframes cxfa-drawn{0%,30%{opacity:1}31%,93%{opacity:0}94%,100%{opacity:1}}
@keyframes cxfa-straight{0%,30%{opacity:0}31%,93%{opacity:1}94%,100%{opacity:0}}
@keyframes cxfa-hit{0%,49%{opacity:1;transform:none}51%{opacity:.4;transform:translateX(1.5px)}55%{opacity:1;transform:translateX(-1px)}60%,100%{opacity:1;transform:none}}
@keyframes cxfa-spark{0%,49%{transform:scale(0);opacity:0}52%{transform:scale(1);opacity:1}70%,100%{transform:scale(1.9);opacity:0}}
@keyframes cxfa-flutter{0%,100%{transform:skewY(0) scaleX(1)}50%{transform:skewY(-4deg) scaleX(1.06)}}
.cxf-art .a-pulse{animation:cxfa-pulse 3.2s ease-in-out infinite}
.cxf-art .a-spin{animation:cxfa-spin 16s linear infinite}.cxf-art .a-spin.slow{animation-duration:36s}
.cxf-art .a-spinr{animation:cxfa-spinr 60s linear infinite}
.cxf-art .a-blink{animation:cxfa-blink 5s ease-in-out infinite}
.cxf-art .a-flick{animation:cxfa-flick 1.6s ease-in-out infinite}.cxf-art .flame{transform-origin:50% 100%!important}
.cxf-art .a-glow{animation:cxfa-glow 2.4s ease-in-out infinite}
.cxf-art .a-rise{animation:cxfa-rise 3.2s ease-out infinite}
.cxf-art .a-float{animation:cxfa-float 3.6s ease-in-out infinite}
.cxf-art .a-wave{animation:cxfa-wave 5s linear infinite}
.cxf-art .a-arrow,.cxf-art .a-drawn,.cxf-art .a-straight,.cxf-art .a-hit,.cxf-art .a-spark{animation-duration:4.6s;animation-iteration-count:infinite}
.cxf-art .a-arrow{animation-name:cxfa-arrow;animation-timing-function:ease-in}
.cxf-art .a-drawn{animation-name:cxfa-drawn}.cxf-art .a-straight{animation-name:cxfa-straight}
.cxf-art .a-hit{animation-name:cxfa-hit}.cxf-art .a-spark{animation-name:cxfa-spark;animation-timing-function:ease-out}
.cxf-art .a-flutter{animation:cxfa-flutter 2.8s ease-in-out infinite;transform-origin:100% 50%!important}
@media(prefers-reduced-motion:reduce){.cxf-art *{animation:none!important}}
`;

// One festive banner. `iso` is the date being shown (today on the dashboard, a
// sample date on the settings page); `note` is the firm's optional note.
export default function FestiveBanner({ festival, iso, signOff, note, T, darkMode }) {
  if (!festival) return null;
  const [from, to] = festivalRange(festival, iso.slice(0, 4));
  const dates = from === to ? formatShortDate(from) : `${formatShortDate(from)} – ${formatShortDate(to)}`;
  const tag = festivalTag(festival, iso, note);
  const vars = {
    '--f1': festival.f1, '--f2': festival.f2,
    '--fa': darkMode ? `color-mix(in srgb, ${festival.f1} 40%, #ffffff)` : festival.f1,
    '--card': T.cardBg, '--text': T.text, '--muted': T.text2, '--line': T.border,
    '--chakra': darkMode ? '#93a8e8' : '#1e3a8a',
  };
  return (
    <div className={`cxf${festival.tri ? ' tri' : ''}`} style={vars} role="note" aria-label={festival.title}>
      <style>{CSS}</style>
      <div className="cxf-tx">
        <div className="cxf-eb">{festival.name} · {dates}{tag && <span className="cxf-tg">{tag}</span>}</div>
        <div className="cxf-ti">{festival.title}</div>
        <div className="cxf-su">{festival.sub}{signOff ? <> <b className="cxf-sg">— Team {signOff}</b></> : null}</div>
        <div className="cxf-th">“{festival.thought}”</div>
      </div>
      <div className="cxf-art" aria-hidden="true" dangerouslySetInnerHTML={{ __html: FESTIVE_ART[festival.art]() }} />
    </div>
  );
}
